import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import VipRewardsModal from "../vip-rewards-modal";
import { useEffect } from "react";

const RewardsItem = props =>{
    const { rewards, userLevel, themeColor, upgradeFlag, index, currentLevel, setModalIndex } = props;

    const selectedReawrdsEvent = (index,rewards) =>{
        setModalIndex(index);

        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: rewards.refId,
                page_sort:"VIP",
                page_content:"Rewards"
            })
        }
    }

    return <div onClick={() =>selectedReawrdsEvent(index,rewards)}>
        <span className={cls.BgIcon} style={{backgroundImage: `url(${rewards?.icon})`}}>
            {
                (userLevel < rewards.level) && <span className={cls.RewardLock}>
                    <span className={cls.Container} style={{backgroundColor:`${themeColor[rewards.level]}`}}>
                        <Iconfont className={cls.Icon}>&#xe70c;</Iconfont> <span className={cls.Level}>v{rewards.level}</span>
                    </span>
                </span>
            }
            
            {
                userLevel==rewards.level && currentLevel==rewards.level && upgradeFlag && <span className={cls.RewardLock}>
                    <span className={`${cls.Container} ${cls.NewLevel}`} style={{backgroundColor: `${themeColor[rewards.level]}`}}>
                        <span className={cls.Level}><FormattedMessage id="new_in" defaultMessage="New" /></span>
                    </span>
                </span>
            }
            
        </span>
        <p className={cls.Font}>{rewards.title}</p>
    </div>
}

const RewardsConatiner = props =>{
    const { currentVipStyle, showFullHeight } = props;

    return <div className={`${cls.RewardsContainer} ${showFullHeight?cls.FullHeight:""}`}>
        {
            currentVipStyle?.rewards.map((rewards, index) =>(
                <RewardsItem key={index+rewards.id} {...props} index={index} rewards={rewards} />
            ))
        }
        
    </div>
}

export default props =>{
    useStyles(cls);
    const { currentVipStyle, userLevel, themeColor, upgradeFlag, currentLevel } = props;
    const global = useSelector(state=>state.global);
    const { config } = global;
    const [showFullHeight, setShowFullHeight] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);
    const [sensorIndex, setSensorIndex] = useState(0);

    useEffect(() =>{
        if(!showModal){
            let reward = currentVipStyle?.rewards[sensorIndex];
            if(window.GeekoSensors){
                window.GeekoSensors.Track('ELClick', {
                    clicks: reward?.refId,
                    page_sort:"VIP",
                    page_content:"Rewards",
                    get_rewards:false
                })
            }
        }
    }, [showModal, sensorIndex, currentVipStyle]);

    return <div className={cls.VipRewards}>
        <div className={cls.Title}><FormattedMessage id="vip_rewards" defaultMessage="{name} Vip Rewards" values={{name:config?.name}} /></div>
        <div className={cls.NextTitle}><FormattedMessage id="level_up_unlock" defaultMessage="level up to unlock" /></div>

        <RewardsConatiner 
            currentVipStyle={currentVipStyle} 
            currentLevel={currentLevel} 
            userLevel={userLevel} 
            themeColor={themeColor} 
            upgradeFlag={upgradeFlag} 
            showFullHeight={showFullHeight} 
            setModalIndex={(index)=>{
                setModalIndex(index);
                setShowModal(true);
            }}
        />
    
        <div className={cls.ViewRewards}>
            <span onClick={()=>setShowFullHeight(state=>!state)}>
                <span><FormattedMessage id="view_rewards" defaultMessage="View Rewards" /></span>
                <Iconfont className={`${cls.Icon} ${showFullHeight?cls.Active:""}`}>&#xe779;</Iconfont>
            </span>
        </div>

        <VipRewardsModal 
            show={showModal} 
            onClose={()=>setShowModal(false)}
            rewards={currentVipStyle?.rewards}
            modalIndex={modalIndex} 
            themeColor={themeColor} 
            userLevel={userLevel} 
            upgradeFlag={upgradeFlag} 
            setSensorIndex={setSensorIndex}
        />
    </div>
}